export function redirectWithoutSSOToken() {
  const removeSSOToken = () => {
    console.log('removeSSOToken');
    window.removeEventListener('load', removeSSOToken);
    const url = new URL(window.location);
    url.searchParams.delete('ssoToken');
    window.history.pushState('', '', url);
  };
  window.addEventListener('load', removeSSOToken);
}
